import { FunctionComponent, useRef } from "react";

import { Spinner } from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { DataFetcher } from "@ui-components/data-fetcher/DataFetcher.tsx";

import { ClaimManagementScreenBaseProps } from "../claim/types/claim.types.ts";
import { ClaimDataFetcher } from "../shared-components/ClaimDataFetcher.tsx";
import { ClaimDischargeForm } from "./components/ClaimDischargeForm.tsx";
import { DischargeContext } from "./context/DischargeContext.ts";
import { DischargeHelper } from "./context/DischargeHelper.ts";

const ClaimDischargeScreenBase: FunctionComponent<
  ClaimManagementScreenBaseProps
> = ({ claim }) => {
  const root = useStores();

  const dischargeHelper = useRef<DischargeHelper>(
    new DischargeHelper(root, claim)
  );

  return (
    <DataFetcher
      fallback={<Spinner />}
      fetch={dischargeHelper.current.getClaimDischargeClinicalData}
    >
      {() => {
        return (
          <DischargeContext.Provider value={dischargeHelper.current}>
            <ClaimDischargeForm />
          </DischargeContext.Provider>
        );
      }}
    </DataFetcher>
  );
};

const ClaimDischargeScreen: React.FC = () => {
  const { routing } = useStores();
  const claimId = routes.claims.discharge.edit.match(routing.location.pathname)
    ?.params.id;

  return (
    <ClaimDataFetcher fetchProvider fetchPatient claimId={claimId}>
      {claim => <ClaimDischargeScreenBase claim={claim} />}
    </ClaimDataFetcher>
  );
};

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default ClaimDischargeScreen;
